import { TranslationString } from 'shared/entities/localization';

export type AgentPlatformTokenServer = {
  _id: string;
  name: string;
  date_created: string;
  token_masked: string;
};

export enum CreateAgentPlatformTokenError {
  tokenAlreadyExists = 'token_already_exists'
}

export const mapCreateAgentPlatformTokenErrorToMessage =
  (code: CreateAgentPlatformTokenError): TranslationString =>
  (t) =>
    t(`integrations.agentPlatform.errors.${code}`, { ns: 'entities' });
